import {
  WhiteLayerSettings,
  WhiteLayerWarning,
} from "../../types/whiteLayer";

/**
 * Builds warnings based on current settings.
 * Centralized so both page + future export logic use the same rules.
 */
export function buildWarnings(settings: WhiteLayerSettings): WhiteLayerWarning[] {
  const warnings: WhiteLayerWarning[] = [];

  if (settings.edgeTightness <= 1) {
    warnings.push({
      id: "halo-risk",
      level: "warning",
      title: "Halo Risk",
      message:
        "Low edge tightness may cause visible white halo around artwork edges.",
    });
  }

  if (settings.whiteStrength >= 92 && settings.darkReduction <= 25) {
    warnings.push({
      id: "heavy-print",
      level: "warning",
      title: "Heavy Print Feel",
      message:
        "High white strength with low dark reduction may result in a stiff or heavy print.",
    });
  }

  if (settings.fadeSupport <= 10) {
    warnings.push({
      id: "fade-loss",
      level: "warning",
      title: "Fade Loss Risk",
      message:
        "Low fade support may cause soft edges and transparency to break or disappear.",
    });
  }

  if (settings.noiseCleanup <= 3) {
    warnings.push({
      id: "noise",
      level: "info",
      title: "Noise Present",
      message:
        "Low noise cleanup may leave small unwanted white pixels in the print.",
    });
  }

  if (settings.darkReduction >= 80) {
    warnings.push({
      id: "color-support-loss",
      level: "danger",
      title: "Color Support Loss",
      message:
        "Very high dark reduction may cause darker colors to look weak or washed out.",
    });
  }

  if (warnings.length === 0) {
    warnings.push({
      id: "balanced",
      level: "success",
      title: "Balanced Settings",
      message:
        "Your current settings look well balanced for most DTF prints.",
    });
  }

  return warnings;
}
